import React, { Component } from 'react';
import { IBarChartProps, IBarChartState } from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import BarChartComponent from '@kurtosys/ksys-app-components/dist/components/charting/BarChart';
import { utils } from '@kurtosys/ksys-app-template';

@inject('appStore', 'barChartStore', 'queryStore')
@observer
export class BarChart extends Component<IBarChartProps, IBarChartState> {
	static configurationKey: 'barChart' = 'barChart';
	static styleKey: 'barChart' = 'barChart';
	constructor(props: IBarChartProps) {
		super(props);
	}
	render() {
		const { className, barChartStore, showTable, appStore, queryStore } = this.props;

		if (!barChartStore || !appStore || !queryStore) {
			return null;
		}

		const { barChartProps, hasData, noDataPlaceholder, debugLogs } = barChartStore;
		if (debugLogs) {
			console.log('Bar Chart Debug Log: ', { barChartProps });
			console.log('Bar Chart Debug Log: ');
			console.log(JSON.stringify(barChartProps));
		}
		if (showTable && barChartProps) {
			barChartProps.disclaimersProps = undefined;
		}
		return (
			<Wrapper className={ className }>
				{ (hasData || utils.typeChecks.isNullOrUndefined(noDataPlaceholder)) && <BarChartComponent { ...barChartProps } queryStore={ queryStore } appKey={ appStore.appKey } /> }
				{ !hasData && noDataPlaceholder }
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(BarChart, 'barChart');
